'use strict';

require('../../../modules/es.array.filter');
var getBuiltInPrototypeMethod = require('../../../internals/get-built-in-prototype-method');
module.exports = getBuiltInPrototypeMethod('Array', 'filter');